import { BaseModifier } from "./base-modifier";
export class CheckboxModifier extends BaseModifier {
    constructor() {
        super(":checkbox");
    }
    initialize() { }
    prepareValue(formData, name) {
        return new Promise((resolve) => {
            if (this.input.jQueryObject.is(":checked")) {
                formData.set(name, this.input.jQueryObject.val());
            }
            else {
                formData.delete(name);
            }
            resolve();
        });
    }
}
